import { type UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/provider';

import { expVal } from '@confluence/feature-experiments';
import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient';

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
	spaceContextOnly = false,
}) => {
	const options: UsePreFilteredExtensionsQueryOptions = {
		client: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context:
			spaceContextOnly && expVal('confluence_fix_space_apps_flickering', 'isEnabled', false)
				? { spaceKey }
				: { spaceKey, contentId },
		includeHidden,
	};

	return options;
};
